<footer class="app-container footer">
  <video
    class="background-video"
    autoplay
    muted
    loop
    playsinline
    preload="metadata">
    <source
      src="/video/footer-360.mp4"
      type="video/mp4"
      media="(max-width: 639px)" />
    <source
      src="/video/footer-720.mp4"
      type="video/mp4"
      media="(max-width: 1023px)" />
    <source
      src="/video/footer-1366.mp4"
      type="video/mp4"
      media="(max-width: 1679px)" />
    <source src="/video/footer-1920.mp4" type="video/mp4" />
  </video>

  <div class="content">
    <div class="top-row">
      <a href="https://pirexpo.com/" target="_blank" rel="noopener">
        <svg-icon class="logo" src="/icons/pir-expo.svg" />
      </a>

      <div class="contacts">
        <a href="tel:+7495118-27-13" class="phone-link"> +7 (495) 118-27-13 </a>

        <div class="social-icons">
          <a
            *rxFor="let social of socialLinks; trackBy: 'name'"
            [href]="social.url"
            [attr.aria-label]="social.name"
            target="_blank"
            rel="noopener">
            <svg-icon
              class="social-icon"
              [class.social-icon--wide]="social.wide"
              [class.social-icon--narrow]="!social.wide"
              [src]="social.icon" />
          </a>
        </div>
      </div>
    </div>

    <nav>
      <ul class="nav-list">
        <li *rxFor="let item of menuItems; trackBy: 'name'">
          <span class="nav-item">
            @if (item.isLink) {
              <a [href]="item.url" target="_blank" rel="noopener noreferrer">
                {{ item.name }}
              </a>
            } @else {
              <a
                [routerLink]="item.url ?? ''"
                [fragment]="item.scrollToElement">
                {{ item.name }}
              </a>
            }
          </span>
        </li>
      </ul>
    </nav>

    <div class="bottom-row">
      <div class="legal-info">
        <span class="legal-text">
          &copy; ООО Ярмарка ПИР, 1997&ndash;{{ currentYear }}.
          <br class="mobile-break" />Все права защищены.
        </span>

        <span class="legal-text"> ИНН 7714905086 ОГРН 1137746398910 </span>

        <span class="legal-text">
          Юридический адрес: 125124, город Москва, ул. 3-Я Ямского Поля, д. 2 к.
          26, эт/пом/ком 1/V/71
        </span>

        <div class="legal-links">
          <a
            class="legal-text"
            target="_blank"
            href="/files/Публичная_оферта_договора_оказания_услуг_по_организации_Мероприятий_в_рамках_Форума_поваров_ЗШ_2025.pdf"
            >Публичная оферта</a
          >
          <a
            class="legal-text"
            target="_blank"
            href="/files/Политика_в_отношении_обработки_персональных_Ярмарка_ПИР_на_ЗШ.pdf"
            >Политика обработки персональных данных</a
          >
          <div class="legal-link-wrapper">
            <a
              class="legal-text"
              target="_blank"
              href="/files/Правила_посещения_мероприятий_ЗШ.pdf"
              >Правила посещения</a
            >
          </div>
        </div>
      </div>

      <div class="credits">
        <span>Сайт&nbsp;сделан </span>
        <a
          class="credits-link"
          href="https://babushka-agency.ru/"
          rel="noopener">
          <svg-icon class="credits-logo" src="/icons/babushka.svg" />
        </a>
      </div>
    </div>
  </div>
</footer>
